import React, { useEffect } from "react";
import { PageHero } from "../components/PageHero";
import { FaqSection } from "../components/FaqSection";

const Faq = () => {
  useEffect(() => { document.title = "FAQ | Iron Shield Veterans Reset Center"; }, []);
  return (
    <>
      <PageHero
        eyebrow="Help Center"
        lines={["Questions?", "We have answers."]}
        intro="Clear, transparent answers for veterans, case managers, and supporting families. Search or filter by topic below."
      />
      <FaqSection />
    </>
  );
};

export default Faq;
